var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.$t('instance.data_model.form_editor.fields_types.text_field.default_field'),"rules":_vm.rules,"disabled":_vm.readOnly},on:{"change":_vm.emitValue},model:{value:(_vm.valueCopy),callback:function ($$v) {_vm.valueCopy=$$v},expression:"valueCopy"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-598c8d12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Instance/DataModel/FormEditor/FieldsTypes/txt-field.vue
// module id = wK7J
// module chunks = 1